export const FC360_REMEMBERED_INTEGRATED_ACCESS_KEY =
  'fc360RememberedIntegratedAccess';

// Param ya viene cifrado por el emisor. Solo el servicio debe descifrarlo.
export function rememberIntegratedParam(param, context) {
  if (typeof param !== 'string' || !param.trim() || !context) return;

  try {
    window.sessionStorage.setItem(
      FC360_REMEMBERED_INTEGRATED_ACCESS_KEY,
      JSON.stringify({ version: 1, context, param }),
    );
  } catch (_) {
    // Recordar el acceso es opcional; no debe impedir un ingreso validado.
    // Si la escritura fallo por cuota, no reutilizar despues un usuario anterior.
    clearRememberedIntegratedParam();
  }
}

export function getRememberedIntegratedParam(context) {
  try {
    const value = JSON.parse(
      window.sessionStorage.getItem(FC360_REMEMBERED_INTEGRATED_ACCESS_KEY),
    );
    if (
      value?.version === 1 &&
      typeof value.context === 'string' &&
      value.context === context &&
      typeof value.param === 'string' &&
      value.param.trim()
    ) {
      return value.param;
    }
  } catch (_) {}

  return null;
}

export function clearRememberedIntegratedParam() {
  try {
    window.sessionStorage.removeItem(FC360_REMEMBERED_INTEGRATED_ACCESS_KEY);
  } catch (_) {}
}
